import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthContext } from '../models/auth-context.model';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[appHasPermission]',
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private currentAuthContexts: AuthContext[] = [];

  @Input() set appHasPermission(authContexts: AuthContext | AuthContext[]) {
    this.currentAuthContexts = Array.isArray(authContexts) ? authContexts : [authContexts];
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
  ) {}

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(): void {
    const hasPermission =
      this.currentAuthContexts.length === 0 ||
      this.permissionService.hasAnyAuthContext(this.currentAuthContexts);

    this.viewContainer.clear();

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
